export default __webpack_public_path__ + "static/media/location.77df4cf8.svg";